import React from "react";
import "../../css/Trust_Stream.css";
import { motion } from "framer-motion";
import { FiShield, FiLock, FiCpu, FiActivity, FiLayers, FiGlobe } from "react-icons/fi";
import logoIcon from "../../images/favicon.png";

export const Trust_Stream = () => {

  const leftFeatures = [
    { 
      title: "AI-Powered Fraud Detection", 
      desc: "Real-time anomaly detection algorithms scanning 1000+ data points to ensure 0% risk.",
      icon: <FiActivity />
    },
    { 
      title: "Military-Grade Encryption", 
      desc: "256-Bit AES data vaults guaranteeing absolute privacy for your sensitive financial data.",
      icon: <FiLock />
    }
  ];

  const rightFeatures = [
    { 
      title: "Instant Underwriting Engine", 
      desc: "Automated credit decisioning infrastructure processing loan approvals in under 10 minutes.",
      icon: <FiCpu />
    },
    { 
      title: "Distributed Architecture", 
      desc: "Multi-cloud redundant servers ensuring 99.99% uptime and 24/7 seamless access.",
      icon: <FiGlobe />
    }
  ];

  return (
    <section className="ts_v10_wrapper">
      
      {/* Background Decor */}
      <div className="ts_v10_bg_grid"></div>
      
      <div className="ts_v10_container">
        
        <div className="ts_v10_header">
          <motion.span
            className="ts_v10_badge"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            SECURITY INFRASTRUCTURE
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Impenetrable <span className="ts_gradient_text">Trust Core.</span>
          </motion.h2>
          <motion.p
            className="ts_v10_desc"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Experience next-generation financial security. Our proprietary systems continuously monitor, encrypt, and protect your data.
          </motion.p>
        </div>

        <div className="ts_v10_dashboard">
          
          {/* Left Column Features */}
          <div className="ts_v10_col left_col">
            {leftFeatures.map((item, index) => (
              <motion.div 
                key={index}
                className="ts_v10_card"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                whileHover={{ scale: 1.05, x: 10 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <div className="ts_v10_icon_box">{item.icon}</div>
                <div className="ts_v10_card_text">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Center Animated Core */}
          <div className="ts_v10_col center_col">
            <div className="ts_v10_core_wrapper">
              
              <motion.div 
                className="core_ring ring_outer"
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
              ></motion.div>
              
              <motion.div 
                className="core_ring ring_inner"
                animate={{ rotate: -360 }}
                transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
              ></motion.div>

              <motion.div 
                className="core_center_shield"
                animate={{ scale: [1, 1.1, 1], boxShadow: ["0 0 20px #2889a6", "0 0 60px #38bdf8", "0 0 20px #2889a6"] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              >
                <img src={logoIcon} alt="ActoLoan" className="core_logo_icon" />
              </motion.div>

              {/* Data streams */}
              <motion.div className="data_stream stream_1" animate={{ height: ["0%", "100%", "0%"], opacity: [0, 1, 0] }} transition={{ duration: 2, repeat: Infinity, delay: 0 }}></motion.div>
              <motion.div className="data_stream stream_2" animate={{ height: ["0%", "100%", "0%"], opacity: [0, 1, 0] }} transition={{ duration: 2.5, repeat: Infinity, delay: 1 }}></motion.div>

            </div>
          </div>

          {/* Right Column Features */}
          <div className="ts_v10_col right_col">
            {rightFeatures.map((item, index) => (
              <motion.div 
                key={index}
                className="ts_v10_card"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                whileHover={{ scale: 1.05, x: -10 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <div className="ts_v10_icon_box">{item.icon}</div>
                <div className="ts_v10_card_text">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};
